import {useState,useEffect,useContext} from 'react'
import './SearchBox.css'
import { Link,useNavigate } from 'react-router-dom';
import { useQueryParam, NumberParam, StringParam } from 'use-query-params';
import { LanguageContext } from '../../context';
import { useTranslate } from '../Translate/Translate';

const SearchBox = () => {

  const [searchText,setSearchText]=useState();
  const [freeText, setFreeText] = useQueryParam('k', StringParam);
  const { language } = useContext(LanguageContext);
  
  const navigate = useNavigate();

  useEffect(()=>{
   
    if(freeText!=undefined){
      setSearchText(freeText);
    }
    else{
      setSearchText('');
    }
  
  },[freeText]);

  const handleChange=(e)=>{
    setSearchText(e.target.value);
  }

  const checkEnter=(e)=>{
    if(e.key=="Enter")
      searchHandle()
  }

  const searchHandle=(e)=>{
    navigate(`/${language}?k=${searchText}`)
  }

  return (
    <div className='searchBox'>
<div className='search_homepage' role="search" id="searchHomepage">
        <div className='search_menu_inside'>
            <div className='searchMainLine'>
         
                {/* <div className='clearSearchLineHP'  role="button"  onkeypress="clearSearchLineHP()" onclick="clearSearchLineHP()"></div> */}
            <input type="text"  role="text" aria-label={useTranslate("Search")} className='txt-Search' value={searchText} onChange={handleChange} onKeyDown={checkEnter}  />
               
              
                
                {/* <Link to={`/search/${searchText}`}> */}
                <button  name="btnSubmitHomepage"  className='btn-submit' onClick={searchHandle} aria-label="חיפוש"/>
                {/* </Link> */}
                
       
            </div>
            </div>
    </div>
    </div>
  )
}

export default SearchBox